var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseColors, colors } from '../../../Themes/colors';
export var WIZARD_COLORS = {
    ink: '#14151C',
    body: '#3C3C3B',
    muted: '#6F6F6D',
    label: '#8A8F98',
    pending: '#C8CCD2',
    brand: '#1F275C',
    page: '#F5F6F7',
    section: '#F9FAFB',
    subHeading: '#F1F3F5',
    highlight: '#EAF2FE',
    surface: baseColors.fullWhite,
    border: '#D6DAE1',
    sectionBorder: '#EDEFF2',
    error: '#D32F2F',
};
export var FORM_FIELD_TOKENS = {
    borderColor: WIZARD_COLORS.border,
    accentColor: baseColors.successPreset[30],
    actionColor: WIZARD_COLORS.ink,
    onAccentColor: baseColors.fullWhite,
    errorColor: WIZARD_COLORS.error,
    labelColor: WIZARD_COLORS.label,
    valueColor: WIZARD_COLORS.ink,
    surfaceColor: WIZARD_COLORS.surface,
    sectionColor: WIZARD_COLORS.section,
    sectionBorderColor: WIZARD_COLORS.sectionBorder,
    highlightColor: WIZARD_COLORS.highlight,
    disabledBg: colors.greyShades[17],
    radius: '6px',
    inputTextColor: '#696F88',
    inputRadius: '4px',
};
export var dynamicFieldSx = {
    '& .MuiInputLabel-root': {
        fontSize: 14,
        fontWeight: 400,
        color: FORM_FIELD_TOKENS.inputTextColor,
        '&.Mui-focused': { color: FORM_FIELD_TOKENS.accentColor },
        '&.Mui-error': { color: FORM_FIELD_TOKENS.errorColor },
        '&.Mui-disabled': { color: FORM_FIELD_TOKENS.labelColor },
    },
    '& .MuiOutlinedInput-root': {
        backgroundColor: baseColors.fullWhite,
        borderRadius: FORM_FIELD_TOKENS.inputRadius,
        fontSize: 14,
        color: FORM_FIELD_TOKENS.inputTextColor,
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: FORM_FIELD_TOKENS.borderColor,
            fontSize: 14,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: FORM_FIELD_TOKENS.accentColor,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: FORM_FIELD_TOKENS.accentColor,
            borderWidth: '1px',
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: FORM_FIELD_TOKENS.errorColor,
        },
        '&.Mui-disabled': {
            backgroundColor: FORM_FIELD_TOKENS.disabledBg,
            '& .MuiOutlinedInput-input': { WebkitTextFillColor: WIZARD_COLORS.muted },
        },
    },
    '& .MuiSelect-select': { cursor: 'pointer' },
    '& .MuiOutlinedInput-input': {
        fontSize: 14,
        color: FORM_FIELD_TOKENS.inputTextColor,
        '&::placeholder': { color: FORM_FIELD_TOKENS.inputTextColor, opacity: 1 },
    },
    '& .MuiFormHelperText-root': {
        marginLeft: 0,
        marginRight: 0,
        fontSize: 11,
        lineHeight: '14px',
    },
};
export var dynamicTextAreaSx = __assign(__assign({}, dynamicFieldSx), { '& .MuiOutlinedInput-root': __assign(__assign({}, (dynamicFieldSx['& .MuiOutlinedInput-root'])), { height: 'auto', padding: '8px 12px' }) });
export var dynamicChoiceLabelSx = {
    display: 'block',
    fontSize: 13,
    fontWeight: 600,
    marginBottom: '6px',
    color: FORM_FIELD_TOKENS.valueColor,
    '&.Mui-focused': { color: FORM_FIELD_TOKENS.valueColor },
    '&.Mui-error': { color: FORM_FIELD_TOKENS.errorColor },
};
export var dynamicAboveLabelSx = function (hasError) { return (__assign(__assign({}, dynamicChoiceLabelSx), (hasError && { color: FORM_FIELD_TOKENS.errorColor }))); };
export var dynamicHelperTextSx = {
    fontSize: 12,
    lineHeight: '16px',
    marginTop: '6px',
    color: WIZARD_COLORS.label,
};
export var dynamicRadioSx = {
    padding: '4px',
    color: FORM_FIELD_TOKENS.accentColor,
    '&.Mui-checked': { color: FORM_FIELD_TOKENS.accentColor },
    '& .MuiSvgIcon-root': { fontSize: 18 },
};
export var dynamicCheckboxSx = {
    padding: '4px',
    color: FORM_FIELD_TOKENS.borderColor,
    '&.Mui-checked': { color: FORM_FIELD_TOKENS.actionColor },
    '& .MuiSvgIcon-root': { fontSize: 18 },
};
export var dynamicBoxedControlSx = {
    display: 'flex',
    alignItems: 'center',
    minHeight: 37,
    padding: '2px 12px',
    borderRadius: FORM_FIELD_TOKENS.radius,
    border: "1px solid ".concat(FORM_FIELD_TOKENS.borderColor),
    backgroundColor: FORM_FIELD_TOKENS.surfaceColor,
};
export var dynamicChipOptionSx = function (isSelected, hasError) { return ({
    minWidth: 62,
    padding: '9px 14px',
    fontSize: 14,
    fontWeight: isSelected ? 700 : 400,
    fontFamily: 'inherit',
    cursor: 'pointer',
    borderRadius: FORM_FIELD_TOKENS.radius,
    color: isSelected ? FORM_FIELD_TOKENS.onAccentColor : FORM_FIELD_TOKENS.valueColor,
    backgroundColor: isSelected ? FORM_FIELD_TOKENS.actionColor : FORM_FIELD_TOKENS.surfaceColor,
    border: "1px solid ".concat(isSelected
        ? FORM_FIELD_TOKENS.actionColor
        : hasError
            ? FORM_FIELD_TOKENS.errorColor
            : FORM_FIELD_TOKENS.borderColor),
    '&:hover': { borderColor: FORM_FIELD_TOKENS.actionColor },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.5 },
}); };
export var dynamicActionButtonSx = function (isPrimary, isCompact) {
    if (isCompact === void 0) { isCompact = false; }
    return (__assign(__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', width: isCompact ? 'auto' : '100%' }, (isCompact && { alignSelf: 'flex-start' })), { minHeight: 37, padding: '8px 14px', fontSize: 14, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', whiteSpace: 'nowrap', borderRadius: FORM_FIELD_TOKENS.radius, color: isPrimary ? FORM_FIELD_TOKENS.onAccentColor : FORM_FIELD_TOKENS.valueColor, backgroundColor: isPrimary ? FORM_FIELD_TOKENS.actionColor : FORM_FIELD_TOKENS.surfaceColor, border: "1px solid ".concat(isPrimary ? FORM_FIELD_TOKENS.actionColor : FORM_FIELD_TOKENS.borderColor), '&:hover': { borderColor: FORM_FIELD_TOKENS.actionColor }, '&:disabled': {
            cursor: 'not-allowed',
            color: '#9AA0A6',
            backgroundColor: colors.greyShades[17],
            borderColor: FORM_FIELD_TOKENS.borderColor,
        } }));
};
export var FIELD_LABEL_SX = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
};
export var REQUIRED_MARK_SX = { color: FORM_FIELD_TOKENS.errorColor };
export var TOOLTIP_ICON_SX = { fontSize: 14, ml: '2px' };
export var OCR_PREFILLED_ICON_SX = {
    fontSize: 15,
    color: '#2E7D32',
    mr: '3px',
};
export var FIELD_ERROR_TEXT_SX = { ml: 0 };
export var dynamicRadioErrorSx = function (isInline) { return (__assign({ ml: 0 }, (isInline && { width: '100%', mt: '2px' }))); };
export var MENU_ITEM_SX = { fontSize: 14, whiteSpace: 'normal' };
export var SELECT_MENU_PROPS = {
    MenuProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        PaperProps: { style: { maxHeight: 260, maxWidth: 0 } },
    },
};
export var SELECT_PLACEHOLDER_SX = { color: FORM_FIELD_TOKENS.labelColor };
export var RADIO_OPTION_LABEL_SX = { fontSize: 13 };
export var START_ADORNMENT_SX = {
    '& .MuiTypography-root': { fontSize: 14, color: FORM_FIELD_TOKENS.labelColor },
};
export var dynamicRadioControlSx = function (isInline) { return (__assign({ width: '100%' }, (isInline && {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: 2,
}))); };
export var dynamicRadioLegendSx = function (isInline) { return (__assign(__assign({}, dynamicChoiceLabelSx), (isInline && {
    marginBottom: 0,
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
}))); };
export var dynamicRadioGroupSx = function (isLabelDetached) { return ({
    gap: 3,
    mt: isLabelDetached ? 0 : 0.5,
    marginLeft: '5px',
}); };
export var CHIP_GROUP_SX = { display: 'flex', flexWrap: 'wrap', gap: 1 };
export var CHECKBOX_LABEL_SX = { fontSize: 13, color: WIZARD_COLORS.body };
export var CHECKBOX_HELPER_TEXT_SX = __assign(__assign({}, dynamicHelperTextSx), { ml: '30px', mt: '-2px' });
export var FILE_ROW_SX = { display: 'flex', alignItems: 'stretch' };
export var FILE_STATUS_TEXT_SX = __assign(__assign({}, dynamicHelperTextSx), { color: WIZARD_COLORS.muted });
export var dynamicFileButtonSx = function (isDisabled) { return ({
    flexShrink: 0,
    padding: '10px 18px',
    fontSize: 14,
    fontWeight: 700,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    color: FORM_FIELD_TOKENS.onAccentColor,
    backgroundColor: FORM_FIELD_TOKENS.actionColor,
    border: "1px solid ".concat(FORM_FIELD_TOKENS.actionColor),
    borderRadius: '6px 0 0 6px',
    '&:hover': { opacity: 0.9 },
}); };
export var dynamicFileNameSx = function (hasFileName, hasError) { return ({
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    fontSize: 14,
    color: hasFileName ? FORM_FIELD_TOKENS.valueColor : FORM_FIELD_TOKENS.labelColor,
    backgroundColor: FORM_FIELD_TOKENS.surfaceColor,
    border: "1px solid ".concat(hasError ? FORM_FIELD_TOKENS.errorColor : FORM_FIELD_TOKENS.actionColor),
    borderLeft: 'none',
    borderRadius: '0 6px 6px 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}); };
export var dynamicSectionSurfaceSx = function (isFilled) { return ({
    backgroundColor: isFilled ? FORM_FIELD_TOKENS.sectionColor : 'transparent',
    border: isFilled ? "1px solid ".concat(FORM_FIELD_TOKENS.sectionBorderColor) : 'none',
    borderRadius: '8px',
    padding: isFilled ? { xs: '16px', md: '16px 20px 20px' } : 0,
}); };
export var SECTION_HEADER_ROW_SX = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mb: 2,
};
export var SECTION_TITLE_SX = {
    fontSize: 14,
    fontWeight: 700,
    color: FORM_FIELD_TOKENS.valueColor,
};
export var dynamicGroupSurfaceSx = function (isCard, isHighlighted) { return (__assign(__assign({ height: '100%' }, (isCard && {
    backgroundColor: FORM_FIELD_TOKENS.surfaceColor,
    border: "1px solid ".concat(FORM_FIELD_TOKENS.sectionBorderColor),
    borderRadius: '8px',
    padding: '14px 16px',
})), (isHighlighted && {
    backgroundColor: FORM_FIELD_TOKENS.highlightColor,
    borderRadius: '6px',
    padding: '8px 16px',
}))); };
export var dynamicGroupTitleSx = function (isCard) { return ({
    fontSize: isCard ? 14 : 13,
    fontWeight: isCard ? 700 : 600,
    color: isCard ? FORM_FIELD_TOKENS.valueColor : WIZARD_COLORS.body,
    mb: 1.25,
}); };
export var RECORD_TAB_BAR_SX = {
    borderBottom: "1px solid ".concat(FORM_FIELD_TOKENS.sectionBorderColor),
    mb: 2,
};
export var RECORD_TAB_STRIP_SX = { minWidth: 0 };
export var RECORD_TABS_SX = {
    minHeight: 38,
    '& .MuiTabs-indicator': {
        backgroundColor: FORM_FIELD_TOKENS.actionColor,
        height: 2,
    },
    '& .MuiTab-root': {
        minHeight: 38,
        padding: '6px 10px',
        fontSize: 13,
        fontWeight: 600,
        textTransform: 'none',
        color: FORM_FIELD_TOKENS.labelColor,
        '&.Mui-selected': { color: FORM_FIELD_TOKENS.actionColor },
    },
};
export var RECORD_ADD_BUTTON_SX = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
    padding: '9px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    color: WIZARD_COLORS.muted,
    cursor: 'pointer',
    border: 'none',
    borderRadius: '6px 6px 0 0',
    backgroundColor: WIZARD_COLORS.subHeading,
    '&:hover': { backgroundColor: '#E7EAEE' },
    '&:disabled': { cursor: 'not-allowed', opacity: 0.5 },
};
export var RECORD_ADD_ICON_SX = { fontSize: 16 };
export var RECORD_REMOVE_BUTTON_SX = {
    padding: '2px',
    color: FORM_FIELD_TOKENS.errorColor,
};
export var RECORD_REMOVE_ICON_SX = { fontSize: 15 };
export var hiddenWhenInactiveSx = function (isActive) { return ({
    display: isActive ? 'block' : 'none',
}); };
export var OPTION_WITH_DESCRIPTION_SX = {
    py: 0.5,
    width: '100%',
    '&:not(:last-child)': { borderBottom: '1px solid #E0E0E0' },
};
export var OPTION_LABEL_SX = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1A1A1A',
    mb: 0.5,
};
export var OPTION_DESCRIPTION_SX = {
    display: 'block',
    fontSize: '11px',
    fontStyle: 'italic',
    color: '#666666',
};
